var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{ref:"mapRef",staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"options":_vm.mapOptions}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m,"icon":"/img/icons/marker.svg"},on:{"click":function($event){return _vm.setCenter(m)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }